<template>
	<div class="page">

		<div class="tableBox">
			<div class="screenLine">
        <div class="screenLineR">
        <el-input
                style="width: 150px; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="page.keyword"
                @keyup.enter.native="clickSearch"
                clearable
              ></el-input>
              <el-button
                @click="clickSearch"
                icon="el-icon-search"
                type="warning"
                >搜索</el-button
              >
      </div>
			<div class="screenLineR">
				<el-button type="warning" @click="edit({})">新增</el-button>
			</div>
		</div>
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column prop="templateCode" label="配置编号">
				</el-table-column>
				<el-table-column prop="templateName" label="配置名称">
				</el-table-column>
				<el-table-column prop="templateContent" label="推送内容">
				</el-table-column>		
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
						<el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
      <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
			
		</div>
		<!-- 添加 编辑 -->
		<div v-if="drawerEdit_state">
			<drawerEdit :id="curItem" @submit="submit_drawerEdit"></drawerEdit>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import drawerEdit from "./drawer_edit.vue"
	export default {
		components: { page,drawerEdit},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0,
          keyword:''
				},
				tableData: [], //表格数据
				
				drawerEdit_state: false,
				curItem: '', //跳转数据
			}
		},
		created() {

		},
		mounted() {
			this.getTableData()
		},
		methods: {
			edit(row){
				console.log(row,"obj111");
				this.curItem = row.id;
				this.drawerEdit_state = true
			},
			//删除
			del(row) {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id: row.id
					}
					this.$http.get(process.env.VUE_APP_Url38 + 'api/WXGZH/Template/Delete', params).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getTableData()
						}
					})
				})
			},
			//关闭弹框
			submit_drawerEdit(obj) {
				this.drawerEdit_state = false;
				if (obj.type == "success") {
					this.getTableData()
				}
			},
			//获取表格
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
      clickSearch() {
      this.page.page = 1;
      this.getTableData();
    },
			getTableData() {
				let params = {
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
                    keyword:this.page.keyword
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url38 + 'api/WXGZH/Template/List', params).then((res) => {
					loading.close()
					if (res.code == 0) {
            console.log(res,"res");
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

		.screenLine {
			display: flex;
      justify-content: space-between;

			.screenLineR {
				// flex: 1;
				// text-align: right;
			}

			.titleSelect {
				width: 130px;
				margin-right: 16px;
			}
		}

		.tableBox {
			padding: 16px;
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16px;
			height: calc(100% - 56px);
		}

		.pagePosi {
			position: absolute;
			bottom: 0;
			left: 16px;
			right: 16px;
			text-align: right;
			background-color: #fff;
			padding: 0 10px;
			border-radius: 8px 8px 0 0;
		}
	}
</style>
